<template>
  <div class='dialogs'>
    <div class="dialog-container form-dialog" v-show="form" @mousedown="form=false">
      <div class="dialog-content" @click.stop="form=true" @mousedown.stop="form=true">
        <div class="dialog-close" @click.stop="form=false"></div>
        <h2><div class="unlock-icon" :number="unlock"><img src="@/assets/img/icon_unlock_black.svg" width="28" height="39"></div> Unlock Challenge <b>{{unlock}}</b></h2>
        <p v-if="!alreadyRegistered">Enter your details below to unlock this harder content</p>
        <div class="form-scroll">
          <form :id="'mktoForm_'+formId" ref="frm" ></form>
          <div class="bar"></div>
        </div>
      </div>
    </div>
    <div class="dialog-container form-dialog" v-show="failWarning" @click="failWarning=false">
      <div class="dialog-content" @click.stop="failWarning=true">
        <div class="dialog-close" @click.stop="failWarning=false"></div>
        <h2>Warning</h2>
        <p>Your browser's security settings are blocking the form from loading. If Private Browsing is enabled, please disable it and reload the page.</p>
        <div class="alert-buttons" >
          <button :class="['alert-button','action-button','small-button']" @click.stop="failWarning=false">OK</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

const resizeFrame = function () {
  const el = document.querySelector('.form-scroll')
  const bar = document.querySelector('.bar')
  const rect = el.getBoundingClientRect()
  if (!el.scrolling) {
    el.addEventListener('scroll', function () {
      const pos = el.scrollTop * 100 / el.scrollHeight
      bar.style.top = pos * 2 + '%'
    })
  }
  el.scrolling = true
  if (el.scrollHeight - rect.height > 1) {
    bar.style.top = 0 + 'px'
    el.scrollTop = 0
    el.setAttribute('scroll', 1)
  } else {
    el.setAttribute('scroll', 0)
  }
}

export default {
  name: 'unlock',
  data: function () {
    return {
      unlock: null,
      failWarning: false,
      form: false,
      formId: 5562,
      alreadyRegistered: false,
      redirect: false
    }
  },
  props: {
  },
  mounted: function () {
    window.addEventListener('resize', resizeFrame)
  },
  methods: {
    unlockChallenge: function (ch) {
      this.$emit('unlockchallenge', ch)
      this.form = false
      this.$store.state.locks[ch] = false
      this.$store.dispatch('store')
    },
    showContactForm: function (ch, redirect) {
      const self = this
      this.unlock = ch
      this.redirect = redirect
      if (window.top.MktoForms2 && !this.loaded && !this.isLoading) {
        self.isLoading = true
        window.MktoForms2.loadForm('//app-sjp.marketo.com', '330-FCH-291', this.formId, function (frm) {
          frm.onSuccess(function (res) {
            self.unlockChallenge(self.unlock)
            if (!self.redirect) {
              return false
            }
          })
          // frm.vals({ FirstName: 'Mr/Ms' })
          self.form = true
          self.loaded = true
          const btn = document.querySelector('button.mktoButton')
          btn.className = 'action-button'
          btn.innerText = 'Unlock'
          const links = document.querySelectorAll('a')
          for (let i = 0; i < links.length; i++) {
            links[i].setAttribute('target', '_new')
          }
          try {
            const el = document.getElementById('honeypot')
            if (el) {
              const row = el.parentNode.parentNode.parentNode
              if (row && row.className === 'mktoFormRow') {
                row.style.display = 'none'
              }
            } else {
              self.alreadyRegistered = true
            }
            // document.getElementById('LblEmail').innerText = 'Email'
            // document.getElementById('LblFirstName').innerText = 'Name'
            // document.getElementById('LastName').setAttribute('placeholder', 'Enter Name')
            // document.getElementById('Email').setAttribute('placeholder', 'Enter business email address')
            // document.getElementById('LblIndustry').innerText = 'Industry'
          } catch (e) {
            self.alreadyRegistered = true
          }
          self.isLoading = false
          self.$nextTick(function () {
            resizeFrame()
          })
        })
      } else if (!window.top.MktoForms2) {
        this.failWarning = true
      } else if (this.loaded) {
        self.form = true
      }
    }
  }
}
</script>

<style scoped lang="scss">
.form-dialog{
  .dialog-content{
    width: 490px;
    padding-bottom: 30px !important;
    h2 {
      font-weight: normal !important;
      line-height: 47px;
      height: 47px;
      box-sizing: border-box;
    }
    p{
      margin-bottom: 8px;
    }
    form{
      margin: auto;
      padding: 0!important;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      width: 100% !important;
    }
    .alert-buttons{
      margin-top: 20px;
    }
    .unlock-icon{
      position: relative;
      display: inline-block;
      font-weight: bold;
      &::after{
        position: relative;
        left: -18px;
        top: -6px;
        width: 20px;
        height: 20px;
        color: #fff;
        font-size: 16px;
      }
      &[number='2']::after{
        content: "2";
      }
      &[number='3']::after{
        content: "3";
      }
    }
  }
  p{
    text-align: left;
  }
}
@media (max-height: 840px) {
   #ge_game .dialog-container .dialog-content{
    h2{
      padding-bottom: 0;
    }
   }
  .form-dialog .dialog-content{
    .unlock-icon{
      img{
        width: 26px;
        height: 36px;
      }
      &::after{
        top: -5px;
      }
    }
  }
}
</style>
<style lang="scss">
.form-scroll{
  overflow-y: scroll;
  max-height: 74vh;
  box-sizing: border-box;
  padding-right: 43px !important;
  scrollbar-width: none;
  position: relative;
  &::-webkit-scrollbar{
    background-color: transparent;
    border-radius: 5px 5px;
    height: 3px;
    display: none;
  }
  &::-webkit-scrollbar-track{
    background-color: transparent;
    border-radius: 3px 3px;
  }
  &::-webkit-scrollbar-thumb{
    background-color: rgba(128,128,128,0.1);
    border-radius: 3px 3px;
  }
  &[scroll='1']{
    .bar{
      display: block;
      width: 5px;
      background-color: rgba(0,0,0,0.1);
      height: 80%;
      position: absolute;
      right: 0;
      top: 0;
      border-radius: 3px 3px;
    }
  }
}
.mktoForm{
  overflow: hidden;
  position: relative;
}
.mktoForm .mktoLabel{
  width: 100% !important;
  margin-top: 0px;
}
.mktoForm input[type=text], .mktoForm input[type=url], .mktoForm input[type=email], .mktoForm input[type=tel], .mktoForm input[type=number], .mktoForm input[type=date], .mktoForm textarea.mktoField, .mktoForm select.mktoField{
  height: 50px;
  font-size: 16px;
  width: 100% !important;
  border-bottom: 1px solid #eee;
  border-radius: 10px !important;
  box-shadow: none !important;
  border: 2px solid rgba(38, 153, 251, 0.4) !important;
  padding: 0 12px !important;
  &.mktoInvalid{
    border: 2px solid rgba(251, 38, 38, 0.4) !important;
  }
}
.mktoForm select{
  background-image: url(../assets/img/arrow-down-white.svg), url(../assets/img/btn-right.svg) !important;
  background-position: 362px 12px, top right !important;
  background-size: 24px 24px, contain !important;
  border-radius: 10px !important;
  box-sizing: border-box !important;
  overflow: hidden;
  color: #8F9297;
  &.mktoValid{
    color: #000;
  }
}
.mktoForm input::placeholder{
  font-style: italic;
}
.mktoForm input:focus, .mktoForm select:focus{
    outline: none;
    box-shadow: 0px 0px 4px 1px rgba(38, 153, 251, 0.5);
}
.mktoRadioList{
  display: flex;
  padding: 0 !important;
  > label{
    margin: 0 30px 0 4px !important;
    padding-left: 8px !important;
  }
  > input{
  }
}
.mktoFieldDescriptor{
  width: 100%;
  float: none;
}
.mktoFieldWrap{
  width: 100%;
}
.mktoAsterix{
  display: none !important;
}
form .mktoFormRow{
  &:nth-child(2){
    width: 48%;
    display: inline-block;
    clear: none;
  }
  &:nth-child(3){
    width: 48%;
    display: inline-block;
    clear: none;
    position: absolute;
    right: 0;
  }
  &:nth-child(18){
    .mktoFormCol{
      margin-bottom: 0 !important;
    }
    .mktoFieldDescriptor{
      width: 100px;
    }
  }
}
.mktoOffset{
  height: 4px !important;
  overflow: hidden;
}
.mktoHtmlText{
  width: 100% !important;
  > p > span{
    font-size: 11px !important;
  }
}
.mktoButtonWrap{
  margin-left: 0 !important;
}
.mktoNotYou{
  display: none;
}
.mktoButtonRow{
  order: 8;
  margin-top: 5px !important;
  padding-top: 12px !important;
  border-top: 1px solid rgba(38, 153, 251, 0.25);
  margin-right: -40px !important;
  margin-left: -40px !important;
  display: flex !important;
  justify-content: center;
}
.mktoForm button[type='submit']{
  margin-top: 16px;
  color: #fff !important;
}
.mktoForm .mktoError .mktoErrorMsg{
  font-size: 16px !important;
}
.mktoForm .mktoGutter{
  height: 1vh !important;
}
.mktoTemplateBox{
  font-size: 18px;
  text-align: center !important;
  margin-top: 20px !important;
}
@media (max-height: 900px){
  .mktoForm input[type=text], .mktoForm input[type=url], .mktoForm input[type=email], .mktoForm input[type=tel], .mktoForm input[type=number], .mktoForm input[type=date], .mktoForm textarea.mktoField, .mktoForm select.mktoField{
    height: 46px;
  }
  .mktoForm .mktoGutter{
    height: 3px !important;
  }
  .mktoForm select{
    background-position: 364px 12px, top right !important;
  }
}
@media (max-height: 800px){
  .mktoForm .mktoLabel{
    margin-top: 0;
  }
  .mktoForm button[type=submit]{
    margin-top: 8px !important;
  }
  .mktoForm input[type=text], .mktoForm input[type=url], .mktoForm input[type=email], .mktoForm input[type=tel], .mktoForm input[type=number], .mktoForm input[type=date], .mktoForm textarea.mktoField, .mktoForm select.mktoField{
    height: 40px;
  }
  .mktoForm select{
    background-position: 367px 8px, top right !important;
  }
  .form-scroll{
    max-height: 70vh;
  }
}
@media (max-height: 660px){
  .mktoForm select{
    background-position: 98% 8px, top right !important;
  }
  .form-scroll{
      padding-right: 5vh !important;
  }
}
</style>
